import type React from 'react'
import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from '../../TextBlock'

import { TextBoxMaxLine1Caption4 } from 'atoms/TextBox/Templates/TextBoxMaxLine1Caption4'
import { TextBoxMaxLine2Footnote5 } from 'atoms/TextBox/Templates/TextBoxMaxLine2Footnote5'
import { Colors } from 'atoms/TextBox/TextBox.h'
import { TextBlockRowGap } from 'blocks/TextBlock'
import { TextBlock } from '../../TextBlock'

export interface ITextBlockHorizontalType4 extends ITextBlockProps {
  children?:
    | React.ReactElement<ITextBoxProps>
    | React.ReactElement<ITextBoxProps>[]
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockHorizontalType4 = ({
  title,
  description,
  rowGap: _unused = TextBlockRowGap.INDENT_10,
  ...rest
}: ITextBlockHorizontalType4): JSX.Element => {
  return (
    <TextBlock {...rest}>
      <TextBoxMaxLine2Footnote5 title={title} />
      {description && (
        <TextBoxMaxLine1Caption4
          title={description}
          color={Colors.TEXT_ICON_SECONDARY}
        />
      )}
    </TextBlock>
  )
}
